import React from 'react'
// import image from '../../assets/2.jpg'
import './hero.css'

const Hero = () => {
    return (
        <div className="image-container">
            {/* <img className="hero-image" src={image} alt={image}/> */}
            <div className="hero-image"></div>
        </div>
    )
}

export default Hero;
